import React, {ReactNode} from 'react';

import Option from 'react-select/lib/components/Option';

import {renderIcon} from './utils';

import type {ExtraPropsType} from '../SweetReactSelect';

interface Props<IT> {
  data: IT;
  label: string;
  isDisabled: boolean;
  selectProps: {
    extraProps?: ExtraPropsType<IT>;
    formatCreateLabel: (inputValue: string) => ReactNode;
    formatOptionLabel: (inputValue: IT) => string | ReactNode;
  };
}

export function SelectOption<IT>({
  isDisabled,
  data: item,
  selectProps,
  label,
  ...other
}: Props<IT>) {
  const {typeIcon} = selectProps.extraProps || {};

  let icon: null | string = null;
  let name: ReactNode;

  if (typeof item === 'string') {
    icon = 'fa fa-plus-circle';
    name = selectProps.formatCreateLabel(item);
  } else if (selectProps.formatOptionLabel) {
    icon = renderIcon(typeIcon, item);
    name = selectProps.formatOptionLabel(item);
  } else {
    icon = renderIcon(typeIcon, item);

    name = label;
  }

  return (
    <Option {...other}>
      <div
        className={`clearfix d-flex align-items-top flex-nowrap mr-2 ${
          isDisabled ? 'text-black-50' : ''
        }`}
        style={{
          wordBreak: 'break-word',
        }}
      >
        {icon != null ? <i className={`mt-1 mr-2 ${icon}`} /> : null}{' '}
        <div>{name}</div>
      </div>
    </Option>
  );
}
